import $ from 'jquery';

const chatBotInit = () => {
    const $chatbotOpenBtn = $('.chatbot-trigger-custom-btn');
    const $chatbotCloseBtn = $('.chatbot-footer-close-btn');
    const $chatbotWrapper = $('.c-chatbot');
    const $chatbotOverlay = $('.chatbot-overlay');
    const $chatbotTrigger = $('.c-chatbot-trigger');

    if (!$chatbotOpenBtn.length || !$chatbotWrapper.length) return;

    // Handle custom button trigger delay and animation
    const delayAttr = $chatbotTrigger.data('delay');
    if (delayAttr) {
        const delayMs = parseInt(delayAttr, 10);
        if (!Number.isNaN(delayMs) && delayMs >= 0) {
            setTimeout(() => {
                $chatbotTrigger.addClass('is-visible');
            }, delayMs);
        }
    } else {
        $chatbotTrigger.addClass('is-visible');
    }

    // Open chatbot
    $chatbotOpenBtn.on('click', e => {
        e.preventDefault();

        if (window.CustomGPT && typeof window.CustomGPT.show === 'function') {
            $chatbotWrapper.addClass('is-open');
            window.CustomGPT.show();
        }
    });

    // Close chatbot
    $chatbotCloseBtn.on('click', e => {
        e.preventDefault();

        if (window.CustomGPT && typeof window.CustomGPT.hide === 'function') {
            window.CustomGPT.hide();
        }

        $chatbotWrapper.removeClass('is-open');
    });

    // Close on overlay click (mobile)
    $chatbotOverlay.on('click', e => {
        e.preventDefault();

        if (window.CustomGPT && typeof window.CustomGPT.hide === 'function') {
            window.CustomGPT.hide();
        }

        $chatbotWrapper.removeClass('is-open');
    });
};

$(() => chatBotInit());
